<div class="modal-backdrop">
  <div
    class="modal-header"
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: rgb(236 237 255 / 21%);
    "
  >
    <span style="text-align: left">{{ modalTittle }}</span>
    <button
      type="button"
      aria-label="Close"
      style="background: none; border: none; font-size: 1.5rem; cursor: pointer"
      (click)="onClose()"
    >
      &times;
    </button>
  </div>
  <div
    class="modal-body motif-row"
    style="
      display: flex;
      margin: 1rem;
      background-color: rgba(255, 255, 255, 0.4);
      padding: 0px;
      height: max-content;
    "
  >
    <!-- Left side: Illustration and step info for updating doc priority -->
    <div class="motif-col-lg-6 _firstHalf">
      <div class="motif-row">
        <div class="motif-col-lg-12 _Image">
          <img src="updateDocPriority.png" alt="Document" />
        </div>
        <div class="motif-col-lg-12 _stepInfo">
          <span class="_step" style="margin-bottom: 12px; display: inline-block"
            >Step 1</span
          ><br />
          <span
            style="text-align: left; margin-bottom: 12px; display: inline-block"
            class="tittle"
            >{{ modalTittle }}</span
          >
          <p style="margin-bottom: 2rem" class="description">
            Make sure all of your engagement information is <br />
            accurate and up to date.
          </p>
          <div
            style="
              display: flex;
              flex-direction: row;
              gap: 1rem;
              margin-bottom: 2rem;
            "
          >
            <span class="_stepLine"></span>
            <span
              class="_stepLine"
              [ngStyle]="
                step == 2
                  ? { 'background-color': 'rgba(69, 78, 255, 1)' }
                  : { 'background-color': 'rgba(255, 255, 255, 1)' }
              "
            ></span>
          </div>
        </div>
      </div>
    </div>

    <!--
      Modal Update Document Priority Component

      This component renders a modal dialog for updating the priority of document instructions.
      - Displays a heading and a brief description.
      - Iterates over `instructionList` to show a select dropdown for each document category, allowing users to set the priority.
      - Each dropdown is labeled with the corresponding document category and marked as required.
      - The select options allow users to choose between Priority 1, Priority 2, and Priority 3.
      - Includes Cancel and Update buttons fixed at the bottom right of the modal.
      - Cancel button triggers `onClose()` method.
      - Update button triggers `update()` method.

      Usage:
        Place this component inside a modal container. Bind `instructionList` to the list of document instructions to be updated.
    -->
    <div class="motif-col-lg-6 _secondHalf">
      <h2 class="tittle">{{ modalTittle }}</h2>
      <div *ngIf="step == 1" class="motif-row">
        <div class="motif-col-lg-12">
          <label
            for="selectLabel"
            style="display: block; margin-bottom: 0.5rem; margin-top: 2rem"
          >
            Version name (required)
          </label>
          <input
            type="text"
            id="tags"
            class="form-control"
            style="width: 100%; padding: 0.5rem; background: #fff"
            placeholder="System|"
            [(ngModel)]="dataElementDetails.Version"
            required
          />
        </div>

        <div class="motif-col-lg-10">
          <label
            for="dependentElement"
            style="display: block; margin-bottom: 0.5rem; margin-top: 2rem"
          >
            Tag (required)
          </label>
          <div style="position: relative; display: flex; align-items: center">
            <input
              type="text"
              id="tags"
              class="form-control"
              style="width: 100%; padding: 0.5rem; background: #fff"
              placeholder="System|"
              [(ngModel)]="newTag"
              required
            />
            <span
              style="
                position: absolute;
                right: 0.75rem;
                cursor: pointer;
                font-size: 1.2rem;
                color: #555;
              "
              (click)="(TagList)"
              aria-label="Clear"
              title="Clear"
              *ngIf="!!TagList"
            >
              &times;
            </span>
          </div>
        </div>
        <div class="motif-col-lg-2">
          <button
            type="button"
            style="margin-top: 63%"
            class="secondary-btn"
            (click)="addTag(newTag)"
          >
            Add Tag
          </button>
        </div>
        <div class="motif-col-lg-12 mt-3">
          <ng-container *ngFor="let tag of TagList">
            <span class="tagborder" *ngIf="TagList.length > 0">
              {{ tag }}
              <span class="remove-tag" (click)="removeTag(tag)"> &times; </span>
            </span>
          </ng-container>
        </div>
      </div>
      <ng-template [ngIf]="step == 2">
        <div class="motif-row">
          <ng-container *ngFor="let stepDetail of stepDetails; let i = index">
            <div class="motif-col-lg-12">
              <label
                for="instructionNotes"
                style="display: block; margin-bottom: 0.5rem; margin-top: 2rem"
              >
                Step {{ stepDetail.InstructionStep }} :
                {{ stepDetail.InstructionType }}
              </label>
              <textarea
                id="instructionNotes"
                class="form-control"
                style="
                  width: 100%;
                  padding: 0.5rem;
                  background: #fff;
                  min-height: 20vh;
                "
                [(ngModel)]="stepDetail.InstructionValue"
                placeholder="Add any notes or instructions here..."
              ></textarea>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <div class="motif-row">
        <div
          class="motif-col-lg-12"
          style="
            position: absolute;
            right: 1.5rem;
            bottom: 1.5rem;
            display: flex;
            gap: 1rem;
            justify-content: flex-end;
            background: transparent;
            z-index: 10;
          "
        >
          <button type="button" class="secondary-btn" (click)="onClose()">
            Cancel
          </button>
          <button
            type="button"
            class="secondary-btn"
            [disabled]="step == 1"
            (click)="step = 1"
          >
            Back
          </button>
          <button
            *ngIf="step == 1"
            motifButton
            color="primary"
            size="small"
            (click)="step = 2"
          >
            Next &rarr;
          </button>
          <button
            *ngIf="step == 2"
            motifButton
            color="primary"
            size="small"
            [disabled]="!hasValidDataElementDetails()"
            (click)="update()"
          >
            Update Changes &rarr;
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
